import { Breakpoint, MarketResearchSearchCriteria } from "@relode/core";
import { Routing } from "@relode/core/domain";
import qs from "qs";
import * as React from "react";

import {
    ClientPublicMarketResearchProvider,
    useClientPublicMarketResearchContext,
} from "./_infra/clientPublicMarketResearchProvider";
import { ClientPublicMarketResearchDesktop } from "./clientPublicMarketResearchDesktop";
import { ClientPublicMarketResearchMobile } from "./clientPublicMarketResearchMobile";

export const ClientPublicMarketResearchContainer = () => (
    <ClientPublicMarketResearchProvider>
        <ClientPublicMarketResearchInnerContainer />
    </ClientPublicMarketResearchProvider>
);

export const ClientPublicMarketResearchInnerContainer = () => {
    const [state, actions] = useClientPublicMarketResearchContext();
    const {
        searchResults: {
            summary: { data: summaryData },
            overview: { data: overViewData },
        },
    } = state;

    const showMarketing =
        overViewData?.isSharedFromAdmin &&
        !!overViewData?.canUpsellMarketResearch;

    const handleSignIn = () => {
        let privateUrl = "/client/market-research";
        if (
            summaryData?.jobTitle &&
            summaryData?.locationId &&
            summaryData?.locationName
        ) {
            const marketResearchCriteria: MarketResearchSearchCriteria = {
                jobName: summaryData?.jobTitle.jobName,
                locationId: summaryData?.locationId,
                locationName: summaryData?.locationName,
            };

            const queryString = qs.stringify(marketResearchCriteria, {
                skipNulls: true,
                addQueryPrefix: true,
                sort: (a, b) => a.localeCompare(b),
            });

            privateUrl = `/client/market-research?${queryString}}`;
        }
        localStorage.setItem("relode:redirectUrl", privateUrl);
        window.location.href = Routing.Account.SIGNIN + "?appName=client";
    };

    return (
        <>
            <Breakpoint desktop>
                <ClientPublicMarketResearchDesktop
                    showMarketing={showMarketing}
                    onSignIn={handleSignIn}
                />
            </Breakpoint>
            <Breakpoint mobile>
                <ClientPublicMarketResearchMobile
                    showMarketing={showMarketing}
                    onSignIn={handleSignIn}
                />
            </Breakpoint>
        </>
    );
};
